export default {
  gray28: '#29313e',
  gray45: '#454E5B',
  gray87: '#6F7987',
  grayC3: '#c3c3c3',
  grayC5: '#c5c5c5',
  grayE: '#eeeeee',
  grayE8: '#E8EBF0',
  grayE1: '#e1e2e0',
  black: '#000000',
  leather: '#b18935',
  transparentLeather: '#B189351A',
  transparentLeatherWarning: 'rgba(177, 137, 53, 0.1)',
  opaqueLeatherWarning: 'rgba(177, 137, 53, 0.3)',
  white: '#FFFFFF',
  whiteA1: '#A1A9B4',
  whiteFd: '#fdfdfd',
  whiteF3: '#F3F5F9',
  whiteF3O49: 'rgba(243, 245, 249, 0.49)',
  whiteD: '#D0D1DC',
  rustyRed: '#d21212',
  transparentRustyRed: 'rgba(209, 19, 19, 0.1)',
  opaqueRustyRed: 'rgba(209, 19, 19, 0.3)',
  red: '#FE5054',
  lightGreen: '#2BD798',
}
